var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManWithMobileBlueIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  "data-name": "Layer 1",
  viewBox: "0 0 539.228 727.778"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M539.228 172.947h-3.999V63.402A63.4 63.4 0 0 0 471.828 0H239.74a63.4 63.4 0 0 0-63.402 63.402v600.974a63.4 63.4 0 0 0 63.402 63.402h232.086a63.4 63.4 0 0 0 63.402-63.402V250.923h4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M474.386 16.495H444.09a22.495 22.495 0 0 1-20.827 30.99h-132.96a22.495 22.495 0 0 1-20.827-30.99h-28.296a47.35 47.35 0 0 0-47.347 47.348v600.092a47.35 47.35 0 0 0 47.347 47.348h233.205a47.35 47.35 0 0 0 47.348-47.348V63.843a47.35 47.35 0 0 0-47.348-47.348"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M223.5 134.488h268.567V593.29H223.5z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M133.304 231.972c12.311 10.26-12.31 42.177-12.31 42.177s58.476 2.28 53.86 2.28-8.464-48.447-8.464-48.447-45.397-6.27-33.086 3.99"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m109.529 361.803 53 19 29 12s19 52 28 75-20 60-20 60 3 11 0 16a54.4 54.4 0 0 0-4 8c-1 2-12 1-24 0s-1-20-1-20 10-40 11-41c.934-.933 3.612-7.973.704-10.528a25.95 25.95 0 0 1-6.537-8.13 30.1 30.1 0 0 0-5.167-7.342s-31.695-46.74-47.347-57.37-52 2-52 2 17.347 26.37 17.347 32.37 1 9 4 11 2 6 2 10 3 12 8 16 6 8 5 16-28 4-28 4l-13-25s-20-32-33-66c-6.5-17 .25-28.5 8.625-35.75a41.4 41.4 0 0 1 29.02-9.764l47.008 2.144-33.653-9.63Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "m284.529 272.803 57-26s20-34 8-38-22 30-22 30l-41 8ZM58.529 290.803s-29 26-30 29-19 11-27-3 18-13 18-13l18-23Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7f8f9",
  d: "m29.182 275.433 31 23 51-18c-9.48 29.678-2.053 61.11-33.189 79.315l118 40c-10.443-42.049 6.05-76.859 20.189-119.315 22.394-11.54 50.484-8.811 81 0v-41l-124 7-19.189 10.315-22.811-6.315c-33.022-5.353-74.279 6.346-102 25"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M105.529 493.803c3 2 8 21 9 28s-8 10-13 11-4 4-7 7-14 4-29 1 7-22 9-23 8-24 8-24 20-2 23 0M188.529 548.803l8 21 7.564 11.347a25.7 25.7 0 0 1 3.632 20.91c-1.274 4.688-3.915 9.118-9.196 10.743-13 4-21-21-21-21s-7-14-12-27 4-20 4-20Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 150.175,
  cy: 220.662,
  r: 23.996,
  fill: "#ffb8b8"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M177.377 214.732a22.83 22.83 0 0 0-1.548-18.547c-3.082-5.466-9.018-10.59-20.43-10.88-24.898-.63-35.688 18.143-34.285 23.648s6.422 18.603 6.422 18.603-3.112-12.612 3.112-13.873 30.345-6.306 37.348-.631a14.23 14.23 0 0 1 5.446 13.243Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 358.182,
  cy: 651.748,
  r: 26,
  fill: "#e6e6e6"
})));
export default SvgManWithMobileBlueIcon;